export default "__VITE_ASSET__d6dce5a8__"